export const debounce = (func, delay) => {
    let timer;
    let delayTime = delay || 300;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delayTime);
    };
};